import React from 'react';
import CustomBox from './CustomBox';

interface DetailsHeaderProps {
    label: string;
}

function DetailsHeader({ label }: DetailsHeaderProps): React.JSX.Element {
    return (
        <CustomBox>
            <h4 className="text-foreground text-xl font-bold">{label}</h4>
        </CustomBox>
    );
}

export default DetailsHeader;
